import Backbone from 'backbone';
const socialLinksModel = Backbone.Model.extend({
    defaults: {
        facebookUrl: null,
        googlePlusUrl: null,
        instagramFeedUrl: null,
        pinterestUrl: null,
        twitterUrl: null,
        youtubeChannelUrl: null,
        livestreamFacebookAppId: null,
    },
    blacklist: ['id'],
    initialize(data) {
        return data;
    },
});

export default socialLinksModel;
